import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableParayNagarawa from "./ScroollTableParayNagarawa";
import FillDetailParayNagarawa from "./FillDetailParayNagarawa";
import { ProductConsumer } from "../../../Context/AddProWakel";
import { Link } from "react-router-dom";
const AllParayNagarawa = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RP_getPrint } = value;
          return (
            <>
              <div>
                <Navbar />
                <div style={{ marginTop: "50px" }}>
                  <div className="row" style={{ backgroundColor: "#2C3539" }}>
                    <div className="col-12 ">
                      <FillDetailParayNagarawa />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 ">
                      <ScroollTableParayNagarawa />
                    </div>
                  </div>
                  <div className="row " style={{ backgroundColor: "#2C3539" }}>
                    <div
                      className="col-lg-12 col-12"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <br />
                      <button
                        onClick={RP_getPrint}
                        className="btn btn-warning btn-lg"
                      >
                        <Link to="/print-paraynagarawa">Print</Link>
                      </button>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default AllParayNagarawa;
